/*
 * Confidential and Proprietary.
 * Do not distribute without Bloom Harbor Gifts consent.
 * Copyright Bloom Harbor Gifts 2019. All rights reserved.
 */

import { gql } from '@apollo/client';
import { GRAPHQL_ENV } from '../../../../gql';

/**
 * @description find product details on a list of part numbers
 * @param {string} domain - brand.domain
 * @param {array} partNumbers - array of SKU's to be fetched
 * @returns {object} data found on findProductByPartNumbers
 */

const findProductsByPartNumbers = (domain, partNumbers) => {
    if (!partNumbers || !Array.isArray(partNumbers)) {
        console.error('findProductsByPartNumbers did not recieve valid partNumbers. partNumbers recieved:', partNumbers);
        return null;
    }

    // convert to valid GQL params
    const arrPartNumbers = `["${partNumbers.join('","')}"]`;

    return (
        gql`{findAvailProductSkusByPartNumbers(brand: "${domain}", environment: "${GRAPHQL_ENV}", partNumbers: ${arrPartNumbers}) {
                name
                partNumber
                longDescription
                shortDescription
                image {
                    name
                    path
                    altText
                    additionalImages
                    snipe
                    snipeImagePath
                    snipeProductEndDate
                    snipeCategoryEndDate
                    snipeProductStartDate
                    snipeCategoryStartDate
                    __typename
                }
                productSkus {
                    id
                    name
                    subscriptionsList {
                        type
                        duration
                        interval
                        __typename
                    }
                    subscriptions {
                        type
                        duration
                        interval
                        __typename
                    }
                    prices {
                        type
                        value
                        __typename
                    }
                    availability{
                        published
                        displayEndDate
                        earliestDefaultShipDate
                        earliestShipDate
                        deliveryMessage
                        defaultDeliveryMethod
                    }
                    __typename
                }
                __typename
            }
        }`);
};

export default findProductsByPartNumbers;
